import styled from "@emotion/styled";
import IconAdd from "@/assets/images/icon-add.svg?react";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;

export const Root = styled.form`
  padding: 0 20px;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  margin: 30px 0;
`;

export const TextDetail = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #333;
  margin: 0;
`;

export const SubTextDetail = styled.p`
  font-size: 14px;
  font-weight: 00;
  color: #253858;
  margin: 0;
`;

export const StatusText = styled.div`
  border-radius: 100px;
  background-color: #e7e9ed;
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 700;
  color: #395278;
  width: fit-content;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

export const LayoutLeft = styled.div`
  width: 30%;
  display: grid;
  gap: 20px;
  height: fit-content;
  & .card-information > .theme-card-body {
    display: grid;
    gap: 10px;
  }
  & .card-detail > .theme-card-body {
    display: grid;
    gap: 20px;
  }
`;

export const CardDetail = styled.div`
  display: grid;
  gap: 10px;
`;

export const LayoutRight = styled.div`
  width: 70%;
  display: grid;
  gap: 20px;
  height: fit-content;
  & .card-channel {
    background-color: #fff;
    & .theme-accordion-body > div {
      display: grid;
      gap: 24px;
    }
  }
  & .button-add-channel {
    width: fit-content;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  padding: 24px 16px;
  & button {
    width: 92px;
  }
`;

export const DialogMessage = styled.p`
  margin: 0 0 20px 0;
  font-size: 1rem;
  color: #333;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  gap: 12px;
`;

export const ChipGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 15px;
`;
